module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    style: (_vm.height ? 'height:' + _vm.height : ''),
    attrs: {
      "center": _vm.centerPosition.position,
      "zoom": _vm.centerPosition.zoom
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      attrs: {
        "position": m.position,
        "clickable": !!m.popupText,
        "draggable": false,
        "icon": _vm.icon
      },
      on: {
        "click": function($event) {
          _vm.markerClick(index)
        }
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "opened": _vm.markersVisibility[index] === true,
        "content": m.popupText
      },
      on: {
        "closeclick": function($event) {
          _vm.infoWindowClose(index)
        }
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-260e1014!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoogleMap.vue
// module id = 489
// module chunks = 2